import User from "../../api/v2/models/user"

export default User